export default __webpack_public_path__ + "static/item_11-0301fa00ffd8d3313d2044b83b178a91.jpg";